export { IconColumnComponent } from './icon-column.component';
